import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

const InfoErrorCode = ({ message, className = '' }) => {
  return (
    <div
      className={`my-2 ${className}`}
      style={{
        maxWidth: '400px',
        margin: 'auto',
        backgroundColor: '#ffe900',
        color: 'FFE900',
        padding: '5px',
        border: '1px solid black'
      }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <FontAwesomeIcon
          icon={faCircleExclamation}
          style={{ fontSize: '20px', marginRight: '10px' }}
          color={'black'}
        />
        <p style={{ fontFamily: 'Segoe UI', fontSize: '16px', margin: 0, color: 'black' }}>
          {message}
        </p>
      </div>
    </div>
  );
};

export default InfoErrorCode;
